export default __webpack_public_path__ + "static/media/logo.f5363383.svg";